export default __webpack_public_path__ + "static/media/onf-shipping-banner.e5f5b2fa.jpg";